"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.common.yes': 'Tak',
    'profession.common.no': 'Nie',
};
